import {initElements} from '../define/shared'

export default function initCards() {
    initElements('.wac', initCard)
}

/**
 * @param {HTMLElement} root
 */
export function initCard(root) {
    const emailLinks = [].slice.apply(root.querySelectorAll('a.c-contact.is--email'))

    emailLinks.forEach(a => {
        a.addEventListener('click', event => {
            if (event.isTrusted) {
                const src = a.dataset.mailto
                const hexChars = []
                for (let offset = 0; offset < src.length; offset += 2) {
                    hexChars.push(src[offset] + src[offset + 1])
                }
                const email = hexChars.map(c => String.fromCharCode(parseInt(c, 16))).join('')
                a.setAttribute('href', `mailto:${email}`)
            } else {
                event.preventDefault()
            }
        }, { capture: true, once: true })
    })
}
